/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').
    factory('Group_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        var  resourceBooking = $resource( baseUrl +'rest/groups/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET'}
        });
        return resourceBooking;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('Group',["Group_Resource","GroupData","User", function (Group_Resource,GroupData,User)
    {
        var  Group = function (resource)
        {
            this.id = null;
            this.isDeleted = false;
            this.timeCreated = null;
            this.name = null;
            this.comment = null;
            this.companies = [];
            this.users = [];
            this.loadObject(resource);
            GroupData.add(this);
        }
        Group.prototype.loadObject = function(object)
        {
            if (object!==undefined && object!=null)
            {
                if (!this.id)
                    this.id = object.id;
                this.isDeleted = object.isDeleted;
                if (object.timeCreated)
                    this.timeCreated = new Date(object.timeCreated);
                this.name = object.name;
                this.comment = object.comment;
                if (object.users)
                    for (var i=0;i<object.users.length;i++)
                        this.users.push(new User (object.users[i]));
            }
        };
        Group.prototype.getObjectResource = function()
        {
            var rsGroup = new Group_Resource();
            rsGroup.id = this.id;
            rsGroup.isDeleted = this.isDeleted;
            rsGroup.name = this.name;
            rsGroup.comment = this.comment;
            rsGroup.users = [];
            if (this.users)
                for (var i=0;i<this.users.length;i++)
                    rsGroup.users.push(this.users[i].getObjectResourceForGroup());
            rsGroup.companyCodes = [];
            if (this.companies)
                for (var i=0;i<this.companies.length;i++)
                    rsGroup.companyCodes.push(this.companies[i].code);
            return rsGroup;
        };
        Group.prototype.addCompany = function(company)
        {
            var index = this.companies.indexOf(company);
            if (index==-1)
                this.companies.push(company);
            company.group = this;
        };
        Group.prototype.removeCompany = function(company)
        {
            var index = this.companies.indexOf(company);
            if (index!=-1)
                this.companies.splice(index,1);
            company.group = null;
        };
        Group.prototype.getId = function()
        {
            return this.id;
        };

        Group.prototype.setId = function(id)
        {
            this.id = id;
        };
        return Group;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('GroupSrv',["$log","Group_Resource","UserActionData","Group","GroupData","ServerSrv",
        function ($log,Group_Resource,UserActionData,Group,GroupData,ServerSrv)
        {
        var  groupSrv = {};

        groupSrv.query = function(successFunction,errorFunction)
        {
            Group_Resource.query(
                {}, //params
                function (data) {   //success
                    GroupData.clear() ;
                    for (var i=0;i< data.length;i++)
                        new Group(data[i]);//Auto Add to GroupData
                    if (successFunction!== undefined)
                        successFunction(GroupData.indexGroups);

                },
                function (data) {   //failure
                    $log.error("Group_Resource.query error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);
                });
        };
        groupSrv.save = function(group,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(groupSrv.saveSync, group, successFunction, errorFunction);
        };
        groupSrv.saveSync = function(group,successFunction,errorFunction)
        {
            //$timeout (function () {

            var GroupRes = group.getObjectResource();
            GroupRes.$save({},
                function (data) {
                    try{
                        group.setId(data.id);
                        if (data.userIds)
                            for (var i=0;i<data.userIds.length && i<group.users.length;i++)
                                group.users[i].id =data.userIds[i];
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        groupSrv.remove = function(group,successFunction,errorFunction)
        {
            GroupData.remove(group);
            ServerSrv.startSavingProcess(groupSrv.removeSync, group, successFunction, errorFunction);
        };
        groupSrv.removeSync =  function(group,successFunction,errorFunction)
        {
            //$timeout (function () {

            var groupSrv = new Group_Resource();
            groupSrv.$remove({id:group.getId()}, //params : id
                function (data) {
                    try{
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        groupSrv.restore = function(group,successFunction,errorFunction)
        {
            GroupData.restore(group);
            ServerSrv.startSavingProcess(groupSrv.restoreSync, group, successFunction, errorFunction);
        };
        groupSrv.restoreSync = function(group,successFunction,errorFunction)
        {
            //$timeout (function () {

            var GroupRes = group.getObjectResource();
            GroupRes.$save({}, //no params
                function (data) {
                    try{
                        group.setId(data.id);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        groupSrv.get =  function(id,successFunction,errorFunction)
        {
            Group_Resource.get(
                {id:id}, //params
                function (groupResource) {
                    if (successFunction!=undefined)
                        successFunction(new Group(groupResource));
                },
                function (data) {
                    if (errorFunction !=undefined)
                        errorFunction(data);
                });
        };

        groupSrv.updateLocally =  function(id,resource)
        {
            var group =  GroupData.getById(id)
            if (group!=null)
                group.loadObject(resource);
            return group;
        };
        groupSrv.removeLocally =  function(id,resource)
        {
            var group =  GroupData.getById(id)
            if (group!=null)
                GroupData.remove(group);
            return group;
        };
        groupSrv.addLocally =  function(id,resource)
        {
            var group =  GroupData.getById(id);
            if (group!=null) //check if resource already exist inside index (current action could be a 'cancel')
            {
                group.loadObject(resource);
                GroupData.add(group);
            }
            else
            {
                group = new Group(resource);
                group.id = id;
            }
            return group;
        };

        return groupSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('GroupData',["$filter", function ($filter)
    {
        var  custDataSrv =
        {
            indexGroups : [],
            activeGroups : [],
            deletedGroups : []//deleted items
        };
        custDataSrv.getById =  function(groupId)
        {
            for (var i=0;i<this.indexGroups.length;i++)
                if (this.indexGroups[i].getId()==groupId)
                    return this.indexGroups[i];
            return null;
        }
        custDataSrv.getByIndex =  function(index)
        {
            if (index>=0 && index <this.indexGroups.length)
                return this.indexGroups[index];
            return null;
        }
        custDataSrv.getIndexOf =  function(group)
        {
            if (group)
                return this.indexGroups.indexOf(group);
            return -1;
        }

        custDataSrv.add =  function(group)
        {
            var groupArray = this.activeGroups;
            if (group.isDeleted)
                groupArray =  this.deletedGroups;
            var index =  this.indexGroups.indexOf(group);
            if (index!=-1)
            {
                var realIndex = groupArray.indexOf(group);
                if (realIndex==-1)
                    groupArray.push(group);
            }
            else
            {
                index = this.indexGroups.length
                this.indexGroups.push(group);
                groupArray.push(group);
            }
            return index;
        }        
        custDataSrv.remove =  function(group)
        {
            var index =  this.activeGroups.indexOf(group);
            if (index!=-1)
            {
                this.activeGroups.splice(index, 1);
                this.deletedGroups.push(group)
                group.isDeleted=true;
            }
        }
        custDataSrv.restore =  function(group)
        {
            var index =  this.deletedGroups.indexOf(group);
            if (index!=-1)
            {
                this.deletedGroups.splice(index, 1);
                this.activeGroups.push(group);
                group.isDeleted=false;
            }
        }
        custDataSrv.clear =  function()
        {
            this.indexGroups = [];
            this.activeGroups = [];
            this.deletedGroups = [];
        }
        custDataSrv.sort =  function()
        {
            this.activeGroups = $filter('orderBy')(this.activeGroups,'name', false);
            this.deletedGroups = $filter('orderBy')(this.deletedGroups,'name', false);
        }

        custDataSrv.getActiveList =  function()
        {
            return this.activeGroups;
        }
        custDataSrv.getDeletedList =  function()
        {
            return this.deletedGroups;
        }
        return   custDataSrv;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/Group.js